import { Component } from 'react';
import { node, number } from 'prop-types';
import styled from 'styled-components/macro';

import modularScale from 'styles/helpers/modular-scale';

const H2 = styled('h2')`
  font-size: ${modularScale(2)};
  margin-bottom: 0.25em;
  margin-top: 2em;
`;

const H3 = styled('h3')`
  font-size: ${modularScale(0)};
  margin-bottom: 0.5em;
  margin-top: 2em;
`;

const H4 = styled('h4')`
  font-size: ${modularScale(-1)};
`;

/** Renders styled components based on the provided markdown */
class HeadingRenderer extends Component {
  render() {
    const { level, children } = this.props;

    switch (level) {
      case 1: {
        return <H2>{children}</H2>;
      }
      case 2: {
        return <H3>{children}</H3>;
      }
      default: {
        return <H4>{children}</H4>;
      }
    }
  }
}

HeadingRenderer.propTypes = {
  children: node.isRequired,
  level: number,
};

export default HeadingRenderer;
